module.exports = __webpack_public_path__ + "img/jn-back.6662b936.png";